export const GROWTH_SETUP_META = {
  eyebrow: 'Google Ads & SEO · Setup',
  titleLead: 'Setup',
  titleAccent: 'checklist',
  description:
    "Integrations and access required for the Google Ads & SEO module. ELVA's team handles most of this for you — you'll only see items that need your input or your webmaster's help.",
  readyTitle: 'Your Google Ads & SEO module is fully operational',
  readyDescription:
    'Everything is configured and ELVA is actively optimizing your marketing. Return any time to check the status of your integrations.',
  progressDescription:
    "ELVA's team is handling most of the setup for you. A few items need input from you or your webmaster — see below for what's blocking full activation.",
  integrationsTitle: 'All integrations',
  integrationsSub: 'Complete status across all connections and configurations for this module.',
  footerNote:
    'ELVA monitors all integrations continuously. If any connection breaks or expires, this page automatically flags it and ELVA works to restore it.',
  webmasterNote:
    'We can reach out to your webmaster directly on your behalf — this is included in your plan.',
  unseededTitle: 'Setup checklist not initialized',
  unseededDescription:
    'This clinic has no setup tasks yet. Tasks are created when your account is provisioned — contact ELVA support if you expected items here.',
} as const;
